import { getSortedI18nNamespaces } from '@/lib/i18n/get-sorted-I18n-namespaces';

const i18nNamespaces = getSortedI18nNamespaces([
   'common',
   'navigation',
   'privacy',
]);

export type PrivacyConfig = {
  i18nNamespaces: typeof i18nNamespaces;
};

export const privacyConfig: PrivacyConfig = {
  i18nNamespaces,
};
